import { FC, ImgHTMLAttributes, PropsWithChildren } from 'react'
import { cn } from '@wellesley/ui'

export type CoverImageProps = PropsWithChildren<
  ImgHTMLAttributes<HTMLImageElement> & {
    ratio?: number
  }
>

export const CoverImage: FC<CoverImageProps> = ({
  src,
  alt,
  ratio = 1,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn('width-full relative', className)}
    style={{ paddingBottom: `${100 / ratio}%` }}
    {...rest}
  >
    <div className="inset-none absolute rounded-[inherit]">
      {src && (
        <img
          className="h-full w-full rounded-[inherit] object-cover"
          src={src}
          alt={alt}
        />
      )}
    </div>
    {children}
  </div>
)
